module.exports = __webpack_public_path__ + "static/media/3.48c92f76.jpg";